import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { RemoveEvent, FileRestrictions, ClearEvent, SelectEvent } from '@progress/kendo-angular-upload';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { IKeyPairValue } from 'src/app/interface/IKeyValuePair';
import { IDocument } from 'src/app/interface/IDocument';
import { Common } from '../../common';
import { CommonService } from 'src/app/service/common/common.service';
import { CommonUtil } from '../../common.util';
import { NotificationService } from '@progress/kendo-angular-notification';
import * as XLSX from 'xlsx';

type AOA = any[][];

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {
  @Input() agreementId: string;
  @Input() awardNumber: string;
  @Input() awardNickName: string;
  @Input() awardTitle: string;
  @Input() awardStatus: boolean;
  @Input() deliverableId: string;
  @Input() agreementYear: string;
  @Input() financialInformationId: string;
  @Input() sourcePage: string;
  @Input() roles: string;
  @Output() eventEmit = new EventEmitter<string>();
  mimeMapping: Map<string, string> = new Map([['csv', 'text/csv'],
  ['jpg', 'image/jpeg'],
  ['jpeg', 'image/jpeg'],
  ['png', 'image/png'],
  ['pdf', 'application/pdf'],
  ['doc', 'application/msword'],
  ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['xls', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['ppt', 'application/vnd.ms-powerpoint'],
  ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  ['rtf', 'application/rtf'],
  ['csv', 'text/csv'],
  ['htm', 'text/html'],
  ['html', 'text/html'],
  ['zip', 'application/zip'],
  ['msg', 'application/vnd.ms-outlook']]);

  constructor(private dialogService: DialogService, private formBuilder: FormBuilder,
              private notificationService: NotificationService,
              private commonService: CommonService) { }

  public uploadFile: any = '';
  public dialogRef: DialogRef;
  public dialogPreviewRef: DialogRef;
  public documentFormGroup: FormGroup;
  public defaultGuid: string = '00000000-0000-0000-0000-000000000000';
  public isDocumentTypeSelected: boolean = true;
  public isDocumentSelected: boolean = true;
  public isExistingDocumentName: boolean = false;
  public validateFile: boolean = true;
  public isValidForm: boolean = true;
  public originalDocumentTypeList: IKeyPairValue[] = [];
  public documentTypeList: IKeyPairValue[] = [];
  public fileName: string = '';
  public file: any = null;
  public token: string = '';
  public uploadFileList: IDocument[] = [];
  public newUploadFileList: IDocument[] = [];
  public deleteDocuments: IDocument[] = [];
  public documentUri: any;
  public SpDocumentName: any;
  public selectedDataItem: any;
  public selectedRowIndex: number;
  public fileExtension: any;
  public orgFileName: any;
  public disabledUploadButton: boolean = false;
  public hideAddDocumentButton: boolean = false;
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: ['.jpg', '.jpeg', '.doc', '.docx', '.png', '.pdf', '.txt', '.xls', '.xlsx', '.msg', '.ppt', '.pptx', '.rtf', '.csv', '.zip', '.htm', '.html']
  };
  public disabledSelectFileButton: boolean = false;
  public isReadOnlyPage: boolean = false;
  public isEnableDocumentDialug: boolean = false;
  public isOverrideDocument: boolean = false;
  public isEditDocumentDialug: boolean = false;
  public disableAddDocButton: boolean = false;
  // Preview
  public data: any;
  public headData: any;
  public isEnableJPG: boolean = false;
  public isEnablemsg: boolean = false;
  public isEnableXLXS: boolean = false;
  public isEnableTXT: boolean = false;
  public isEnablePDF: boolean = false;
  public isEnableDOCX: boolean = false;
  public url: any;
  public documentURI: '';
  public enablePreviewDataItem: any;

  ngOnInit(): void {
    this.initilizeFormControls();
    this.getDocumentType();
    if (this.agreementId) {
      if (this.awardStatus === true) {
        this.isReadOnlyPage = true;
      }else {
        this.isReadOnlyPage = false;
      }
      if (this.roles === 'Observer') {
        this.disableAddDocButton = true;
      } else {
        this.disableAddDocButton = false;
      }
      this.getDocumentDetails();
    }
  }

  initilizeFormControls() {
    this.documentFormGroup = this.formBuilder.group({
      displayFileName: new FormControl(),
      documentType: new FormControl(),
      documentDescription: new FormControl(),
    });
  }

  getDocumentType() {
    this.commonService.getDocumentType().subscribe((response) => {
      this.originalDocumentTypeList = response;
      this.documentTypeList = this.originalDocumentTypeList.slice();
    });
  }

  getDocumentDetails() {
    const getDocumentList: IDocument = {};
    getDocumentList.agreementId = null;
    getDocumentList.deliverableDetailId = null;
    getDocumentList.deliverableId = null;
    getDocumentList.agreementPriorApprovalId = null;
    getDocumentList.financialInformationId = null;
    getDocumentList.agreementNoteId = null;
    getDocumentList.isAllDocument = false;
    if (this.sourcePage === 'documentPage') {
      getDocumentList.agreementId = this.agreementId ? this.agreementId : null;
      getDocumentList.isAllDocument = true;
      this.hideAddDocumentButton = true;
    } else if (this.sourcePage === 'financialMgmtPage') {
      getDocumentList.financialInformationId = this.financialInformationId ? this.financialInformationId : null;
    } else {
      getDocumentList.agreementId = this.agreementId ? this.agreementId : null;
    }
    if (getDocumentList.agreementId || getDocumentList.financialInformationId) {
      this.commonService.getDocument(getDocumentList).subscribe(
        (response) => {
          this.uploadFileList = response.Documents;
          if (this.uploadFileList && this.uploadFileList.length > 0) {
            this.uploadFileList.forEach((ele: any) => {
              ele.createdDate = ele.createdDate ? CommonUtil.UTCToLocal(ele.createdDate) : new Date();
              ele.lastModifiedDate = ele.lastModifiedDate ? CommonUtil.UTCToLocal(ele.lastModifiedDate) : new Date();
            });
          }
        });
    }
  }

  documentTypeChange(data: any) {
    if (data) {
      this.disabledSelectFileButton = true;
    }
  }

  resetPreview() {
    this.url = '';
    this.data = '';
    this.headData = '';
    this.isEnablePDF = false;
    this.isEnableXLXS = false;
    this.isEnableJPG = false;
    this.isEnableTXT = false;
    this.isEnablemsg = false;
    this.isEnableDOCX = false;
  }

  enablePreviewDialog(template: TemplateRef<any>, dataItem: any) {
    if (dataItem.documentURI) {
      this.resetPreview();
      this.enablePreviewDataItem = dataItem;
      const extension = dataItem.documentURI.substr(dataItem.documentURI.lastIndexOf('.') + 1);
      this.dialogPreviewRef = this.dialogService.open({
        title: 'Preview',
        content: template,
        width: 800,
        height: 600,
      });
      Common.loader('show');
      if (extension === 'docx' || extension === 'msg' || extension === 'doc' || extension === 'zip' || extension === 'html') {
        this.isEnableDOCX = true;
        this.documentURI = dataItem.documentURI;
        Common.loader('hide');
      } else {
        this.commonService.downloadDocument(dataItem.documentURI)
          .subscribe((data) => {
            this.documentURI = dataItem.documentURI;
            const blob = this.previewBlob(data, extension);
            if (extension === 'txt') {
              this.isEnableTXT = true;
              const fileReader = new FileReader();
              fileReader.onload = (e) => {
                this.url = e.target.result;
              };
              fileReader.readAsText(blob);
            } else if (extension === 'xlsx' || extension === 'xls' || extension === 'csv') {
              this.isEnableXLXS = true;
              const target = blob;
              const reader: FileReader = new FileReader();
              reader.onload = (e: any) => {
                /* read workbook */
                const bstr: string = e.target.result;
                const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
                /* grab first sheet */
                const wsname: string = wb.SheetNames[0];
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];
                /* save data */
                this.data = ((XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: 0 })) as AOA);
                this.headData = this.data[0];
                this.data = this.data.slice(1); // remove first header record
                const ws2: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[1]];
                this.readDataSheet(ws2, 1);
              };
              reader.readAsBinaryString(target);
            } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
              this.isEnableJPG = true;
              const reader = new FileReader();
              reader.onload = (ev) => {
                this.url = ev.target.result;
              };
              reader.readAsDataURL(blob);
            } else if (extension === 'pdf') {
              this.isEnablePDF = true;
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onload = (ev) => {
                this.url = ev.target.result;
              };
            }
            Common.loader('hide');
          });
      }
    }
  }

  public selectEventHandler(event: SelectEvent) {
    if (event.files && event.files.length > 0) {
      if (!event.files[0].validationErrors) {
        this.uploadFile = event.files[0].rawFile;
        this.isDocumentSelected = true;
        this.onFileSelected(event);
      } else {
        this.uploadFile = this.defaultGuid;
        this.isDocumentSelected = false;
        this.isExistingDocumentName = false;
      }
    }
  }

  onFileSelected(event) {
    const file: File = event.files[0].rawFile;
    const attachment: any = {};
    if (file) {
      Common.loader('show');
      this.disabledUploadButton = false;
      const validateDocumentName = this.uploadFileList.find((ele) => ele.spDocumentName === file.name);
      if (validateDocumentName) {
        this.isExistingDocumentName = true;
        this.selectedDataItem = validateDocumentName;
        Common.loader('hide');
      } else {
        this.fileName = file.name;
        attachment.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
        attachment.agreementName = this.awardTitle;
        attachment.awardNumber = this.awardNumber;
        attachment.nickName = this.awardNickName;
        attachment.agreementYear = this.agreementYear ? this.agreementYear : null;
        attachment.documentType = this.documentFormGroup.controls.documentType.value.Description;
        if (file) {
          this.orgFileName = file.name.split('.');
          this.documentFormGroup.patchValue({ displayFileName: this.orgFileName[0]});
          this.fileExtension = this.orgFileName[1];
        }
        this.commonService.uploadAttachment(attachment, file).subscribe((res: any) => {
          if (res) {
            Common.loader('hide');
            this.documentUri = res;
            const fileName = this.documentUri.substr(this.documentUri.lastIndexOf('/') + 1, this.documentUri.length);
            this.SpDocumentName = fileName.split('.')[0];
            this.disabledUploadButton = true;
            this.isExistingDocumentName = false;
          }
        });
      }
    }
  }

  private readDataSheet(ws: XLSX.WorkSheet, startRow: number) {
    /* save data */
    let datas = (XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: startRow })) as AOA;
    const headDatas = datas[0];
    datas = datas.slice(1); // remove first header record
    for (let i = 0; i < this.data.length; i++) {
      this.data[i][this.headData.length] = datas.filter(x => x[12] === this.data[i][0]);
    }
  }

  async getFileBuffer(file: File): Promise<ArrayBuffer> {
    const buffer = await new Response(file).arrayBuffer();
    return buffer;
  }

  // To validate form
  validateDocumentSave() {
    if (this.documentFormGroup.controls.documentType.value) {
      this.isDocumentTypeSelected = true;
    } else {
      this.isDocumentTypeSelected = false;
    }
    if (!(this.uploadFile === '') || this.validateFile === false) {
      this.isDocumentSelected = true;
    } else {
      this.isDocumentSelected = false;
    }
    this.isValidForm = (this.isDocumentTypeSelected === true && this.isDocumentSelected === true) ? true : false;
    return this.isValidForm;
  }

  public addDocument() {
    if (this.validateDocumentSave()) {
      this.dialogRef.close(this.documentFormGroup.value);
    }
  }

  // To save documents
  public saveDocuments() {
    if (this.newUploadFileList.length > 0) {
      this.newUploadFileList.forEach((element: any) => {
        element.agreementId = this.agreementId;
      });
      this.commonService.saveDocument(JSON.stringify(this.newUploadFileList)).subscribe((response: any) => {
        if (response) {
          this.getDocumentDetails();
        }
      });
    }
  }

  public openUploadDocumentDialog(template: TemplateRef<any>) {
    this.documentFormGroup.reset();
    this.validateFile = true;
    this.isExistingDocumentName = false;
    this.disabledSelectFileButton = false;
    this.isEnableDocumentDialug = true;
    this.isEditDocumentDialug = false;
    this.dialogRef = this.dialogService.open({
      title: 'Documents',
      content: template,
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs instanceof DialogCloseResult) {
        this.isEnableDocumentDialug = false;
        return;
      }
      const newDocument: IDocument = {};
      newDocument.id = this.defaultGuid;
      newDocument.documentTypeId = rs.documentType.DocumentTypeId;
      newDocument.documentTypeName = rs.documentType.Description;
      newDocument.documentName = this.fileName;
      newDocument.displayFileName = this.fileName;
      newDocument.spDocumentName = this.SpDocumentName;
      newDocument.documentURI = this.documentUri;
      newDocument.fileExtensionTypeId = 1;
      newDocument.description = rs.documentDescription;
      newDocument.isActive = true;
      newDocument.agreementYear = this.agreementYear ? this.agreementYear : null;
      newDocument.agreementPriorApprovalId = null;
      newDocument.agreementNoteId = null;
      newDocument.financialInformationId = null;
      newDocument.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
      if (this.financialInformationId) {
        newDocument.financialInformationId = this.financialInformationId;
      } else {
        newDocument.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
      }
      if (!this.isExistingDocumentName) {
        this.newUploadFileList.push(newDocument);
        this.eventEmit.emit(newDocument.agreementId);
      }
      this.fileName = '';
      this.documentUri = '';
    }
    );
  }

  public editDocument(template: TemplateRef<any>, dataItem: any, rowIndex: any) {
    this.selectedDataItem = dataItem;
    this.documentFormGroup.reset();
    this.newUploadFileList = [];
    this.validateFile = false;
    this.isExistingDocumentName = false;
    this.disabledUploadButton = true;
    this.disabledSelectFileButton = true;
    this.isEnableDocumentDialug = true;
    this.fileExtension = '';
    this.isEditDocumentDialug = true;
    if (dataItem.documentName) {
      this.orgFileName = dataItem.documentName.split('.');
      this.fileExtension = dataItem.documentName.substr(dataItem.documentName.lastIndexOf('.') + 1);
    }
    this.documentFormGroup.patchValue({
      displayFileName: this.orgFileName[0],
      documentType: { DocumentTypeId: dataItem.documentTypeId, Description: dataItem.documentTypeName },
      documentDescription: dataItem.description,
    });
    this.dialogRef = this.dialogService.open({
      title: ' ',
      content: template,
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs instanceof DialogCloseResult) {
        this.isEnableDocumentDialug = false;
        return;
      }
      const currentRecord = this.uploadFileList[rowIndex];
      if (this.fileName.trim() && this.fileName !== currentRecord.documentName) {
        this.commonService.deleteDocumnetFile(JSON.stringify(dataItem.documentURI)).subscribe();
      }
      currentRecord.id = dataItem.id;
      currentRecord.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
      const name = rs.displayFileName + '.' + this.fileExtension;
      currentRecord.displayFileName = name;
      currentRecord.spDocumentName = dataItem.spDocumentName;
      currentRecord.documentTypeId = rs.documentType.DocumentTypeId;
      currentRecord.documentTypeName = rs.documentType.Description;
      currentRecord.fileExtensionTypeId = 1;
      currentRecord.description = rs.documentDescription;
      currentRecord.documentName = name ? name : rs.displayFileName;
      currentRecord.documentURI = this.documentUri ? this.documentUri : currentRecord.documentURI;
      currentRecord.isActive = true;
      currentRecord.agreementYear = this.agreementYear ? this.agreementYear : null;
      currentRecord.deliverableId = this.deliverableId ? this.deliverableId : null;
      currentRecord.agreementPriorApprovalId = null;
      currentRecord.agreementNoteId = null;
      currentRecord.financialInformationId = null;
      this.newUploadFileList.push(currentRecord);
      this.eventEmit.emit(currentRecord.agreementId);
    });
    this.fileName = '';
    this.documentUri = '';
  }

  public deleteDocument(dataItem: any, rowIndex: number) {
    this.selectedDataItem = dataItem;
    this.selectedRowIndex = rowIndex;
    if (this.selectedDataItem.documentURI !== null) {
      this.dialogRef = this.dialogService.open({
        title: 'Please Confirm',
        content: 'Are you sure, do you want to delete it?',
        actions: [
          { text: 'Yes', primary: true },
          { text: 'No' }],
        width: 400,
      });
      this.dialogRef.result.subscribe((rs: any) => {
        if (rs.text && rs.text === 'Yes') {
          if (this.selectedDataItem.id) {
            Common.loader('show');
            this.deleteDocuments.push(this.selectedDataItem.id);
            if (this.selectedDataItem.documentURI) {
              this.commonService.deleteDocumnetFile(JSON.stringify(this.selectedDataItem.documentURI)).subscribe((res: any) => {
                if (res) {
                  this.commonService.deleteDocument(JSON.stringify(this.deleteDocuments)).subscribe((response: any) => {
                    if (response) {
                      this.notificationService.show({
                        content: 'This has been deleted.',
                        position: { horizontal: 'center', vertical: 'bottom' },
                        animation: { type: 'fade', duration: 500 },
                        type: { style: 'success', icon: true },
                        hideAfter: 1000,
                      });
                      Common.loader('hide');
                    }
                  });
                }
              });
            } else {
              this.commonService.deleteDocument(JSON.stringify(this.deleteDocuments)).subscribe((response: any) => { });
              Common.loader('hide');
            }
            this.uploadFileList.splice(this.selectedRowIndex, 1);
          } else {
            this.uploadFileList.splice(this.selectedRowIndex, 1);
          }
        }
      });
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Document does not exist',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  public downloadDocument(dataItem: any) {
    if (dataItem.documentURI) {
      Common.loader('show');
      this.commonService.downloadDocument(dataItem.documentURI)
        .subscribe((data) => {
          const anchor = document.createElement('a');
          anchor.download = dataItem.documentName;
          const ext = dataItem.documentURI.substr(dataItem.documentURI.lastIndexOf('.') + 1);
          const blob = this.base64ToBlob(data);
          anchor.href = URL.createObjectURL(blob);
          anchor.dataset.downloadurl = [this.mimeMapping.get(ext), anchor.download, anchor.href].join(':');
          anchor.click();
          Common.loader('hide');
        });
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Document does not exist',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  public base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: 'application/octet-stream' });
  }

  public previewBlob(b64Data, ext: any, contentType = '', sliceSize = 512) {
    let tempdata: any;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    if (ext === 'png') {
      tempdata = new Blob(byteArrays, { type: 'image/png' });
    } else if (ext === 'jpg') {
      tempdata = new Blob(byteArrays, { type: 'image/jpg' });
    } else if (ext === 'jpeg') {
      tempdata = new Blob(byteArrays, { type: 'image/jpeg' });
    } else if (ext === 'pdf') {
      tempdata = new Blob(byteArrays, { type: 'application/pdf' });
    } else if (ext === 'ppt') {
      tempdata = new Blob(byteArrays, { type: 'application/vnd.ms-powerpoint' });
    } else if (ext === 'pptx') {
      tempdata = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    } else if (ext === 'rtf') {
      tempdata = new Blob(byteArrays, { type: 'application/rtf' });
    } else {
      tempdata = new Blob(byteArrays, { type: 'application/octet-stream' });
    }
    return tempdata;
  }

  public clearEventHandler(e: ClearEvent) {
    this.uploadFile = this.defaultGuid;
  }

  public removeEventHandler(e: RemoveEvent) {
    this.uploadFile = this.defaultGuid;
  }

  public overrideYes(data: any) {
    if (data === 'Yes') {
      Common.loader('show');
      if (this.selectedDataItem.id) {
        if (this.selectedDataItem.documentURI) {
          // to delete the existing file.
          this.commonService.deleteDocumnetFile(JSON.stringify(this.selectedDataItem.documentURI)).subscribe();
        }
        // to upload document
        const attachment: any = {};
        this.fileName = this.uploadFile.name;
        attachment.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
        attachment.agreementName = this.awardTitle;
        attachment.awardNumber = this.awardNumber;
        attachment.nickName = this.awardNickName;
        this.commonService.uploadAttachment(attachment, this.uploadFile).subscribe((res: any) => {
          if (res) {
            this.documentUri = res;
            const fileList: IDocument[] = [];
            this.selectedDataItem.documentURI = this.documentUri;
            this.selectedDataItem.displayFileName = this.documentFormGroup.controls.displayFileName.value;
            this.selectedDataItem.documentTypeId = this.documentFormGroup.controls.documentType.value.DocumentTypeId;
            this.selectedDataItem.documentTypeName = this.documentFormGroup.controls.documentType.value.Description;
            this.selectedDataItem.description = this.documentFormGroup.controls.documentDescription.value;
            fileList.push(this.selectedDataItem);
            this.isOverrideDocument = true;
            // to save the agreement document.
            this.commonService.saveDocument(JSON.stringify(fileList)).subscribe((response: any) => {
              if (response) {
                this.getDocumentDetails();
                this.dialogRef.close(this.documentFormGroup.value);
                Common.loader('hide');
              }
            });
          }
        });
      }
    }
    else {
      this.dialogRef.close();
    }
  }
}
